import { render, staticRenderFns } from "./user.vue?vue&type=template&id=82fcc7c4&"
import script from "./user.vue?vue&type=script&lang=js&"
export * from "./user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kasingkhoo/NestJsProjects/ivm_web_ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82fcc7c4')) {
      api.createRecord('82fcc7c4', component.options)
    } else {
      api.reload('82fcc7c4', component.options)
    }
    module.hot.accept("./user.vue?vue&type=template&id=82fcc7c4&", function () {
      api.rerender('82fcc7c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/select/user.vue"
export default component.exports